import { NbSkuConfig } from './types';

export const DEFAULT_CONFIG: NbSkuConfig = {};
